<template>
  <!-- <div :class="[isShowNextBtn ? 'startExes':'startExe']"> -->
  <div :class="[isShowNextBtn ? 'startExes' : 'startExe']">
    <div :class="[isShowNextBtn ? 'startBoxs' : 'startBox']">
      <div class="startNav">
        <h1>[{{ examType }}]{{ detail.title }}</h1>
        <div
          v-if="isShowNextBtn"
          class="timerShow"
        >
          <div>
            <img src="../../assets/examinatSystem/timeIcon.png" />
            <a>Time cost&nbsp;</a><span ref="startTimer">{{ time_html }}</span>
          </div>
          <div v-if="$route.fullPath != '/review'">
            <img src="../../assets/examinatSystem/fileIcon.png" />
            <a>Location <span id="i">{{ num }}</span> of
              <span id="count">{{ total }}</span></a>
          </div>
        </div>
      </div>
      <div :class="[isShowNextBtn ? 'startCons' : 'startCon']">
        <div class="startBlock">
          <div
            class="startICons"
            v-if="
              type === 'DI' && isShowNextBtn && $route.fullPath != '/review'
            "
            @click="showCalculator = !showCalculator"
          >
            <img src="../../assets/examinatSystem/editIcon.png" />
            <p>计算器</p>
          </div>
          <div
            class="startICons"
            v-if="isShowNextBtn && $route.fullPath != '/review'"
            @click="lookEidt"
          >
            <img src="../../assets/examinatSystem/editIcon.png" />
            <p>纠错</p>
          </div>
          <div
            class="startICons"
            v-if="isShowNextBtn && $route.fullPath != '/review'"
            @click="lookCollect"
          >
            <img
              src="../../assets/examinatSystem/setCollectIcon.png"
              v-if="alreadyCollect"
            />
            <img
              src="../../assets/examinatSystem/collectIcon.png"
              v-else
            />
            <p>{{ collectStatus }}</p>
          </div>
          <div
            class="startICons"
            v-if="
              examType != '练习' &&
              isShowNextBtn &&
              $route.fullPath != '/review'
            "
            @click="getMark"
          >
            <img
              src="../../assets/mark.png"
              v-if="markStatus"
            />
            <img
              src="../../assets/nomark.png"
              v-else
            />
            <p>{{ markStatus ? "已标记" : "未标记" }}</p>
          </div>
        </div>
        <div class="startBoxCon">
          <div class="startConLeft"></div>
          <!-- <div class="startConRight" style="width: 100%; height: 650px"><router-view v-if="isRouterAlive"></router-view></div> -->
          <div
            class="startConRight"
            style="width: 100%"
          >
            <router-view
              ref="startText"
              :startText="isStart"
              :nextIndexs="nextIndex"
              v-if="isRouterAlive"
              @changIndex="changIndex"
              @isTips="isTipsFun"
              @changeReview="changeReview"
              @changeMark="changeMark"
            ></router-view>
          </div>
        </div>
      </div>

      <!-- <div class="bottomBtns"> -->
      <div :class="[isShowNextBtn ? 'isbottomBtn' : 'bottomBtns']">
        <div class="leftBtns">
          <div
            class="helpBtn"
            @click="lookHelp"
          >
            <img src="../../assets/examinatSystem/doubtIcon.png" />Help
          </div>
          <div
            class="ExamBtn"
            @click="lookExam"
          >
            <img src="../../assets/examinatSystem/signoutIcon.png" />End Exam
          </div>
          <div
            class="ExamBtn"
            @click="suspend"
            v-if="!shopShow && isShowNextBtn"
          >
            Pause exam
          </div>
        </div>
        <div
          class="rightBtns"
          v-if="explainBtn"
        >
          <div
            class="ExamBtn"
            @click="startExam"
            v-if="isShowSkipBtn"
          >
            跳过说明
          </div>
          <div
            class="helpBtn"
            @click="nextExam"
            v-if="
              isShowNextBtn &&
              !explainTrue &&
              (!ifReview || $route.fullPath == '/review')
            "
          >
            Next →
          </div>
          <div
            v-else-if="ifReview && $route.fullPath != '/review'"
            class="helpBtn"
            @click="back"
          >
            Back →
          </div>
          <div
            class="helpBtn"
            @click="elplainNext"
            v-if="explainTrue"
          >
            Next →
          </div>
        </div>
      </div>
    </div>
    <!-- 纠错弹出框 -->
    <div
      class="eidtPops"
      v-if="editPopTag"
    >
      <div class="answerNav">
        <p>纠错</p>
        <img
          src="../../assets/examinatSystem/closeIcon.png"
          @click="cancelEdit"
        />
      </div>
      <div class="editDiv">
        <p>选择纠错类型：</p>
        <el-select
          v-model="editVal"
          placeholder="请选择"
        >
          <el-option
            v-for="item in editType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="editDiv">
        <p class="errText">描述错误内容:</p>
        <textarea
          class="textText"
          name=""
          v-model="editArea"
          rows="7"
          placeholder="例如：答案显示的是B，正确答案应该是C，因为......"
        ></textarea>
      </div>
      <div class="editBtns">
        <button @click="yesEdit">提交</button>
        <button @click="cancelEdit">取消</button>
      </div>
    </div>
    <!-- 帮助提示弹窗 -->
    <div
      class="tagPopupHelp"
      v-if="tagHelp"
    >
      <div class="tagHelpNav">
        <div class="TagnavLeft">
          <img
            class="doubt"
            src="../../assets/examinatSystem/doubtIcon.png"
          />
          <p>Help</p>
        </div>
        <div
          class="tagnavRight"
          @click="hiddenHelp"
        >
          <img src="../../assets/examinatSystem/closeIcon.png" />
        </div>
      </div>
      <div class="tagHelpCon">
        <ul>
          <li>
            右上角的时钟图标<img src="../../assets/examinatSystem/timeIcon.png" />点击可以打开和关闭计时器
          </li>
          <li>
            右上角的文件夹<img src="../../assets/examinatSystem/fileIcon.png" />点击可以打开和关闭当前题号
          </li>
          <li class="conCell">
            登录后点击右上角的星星图标<img src="../../assets/examinatSystem/collectIcon.png" />，所有被收藏的题目均可在“我的GMAT”-“收藏夹”中找到
          </li>
          <li class="conCell">
            点击右下角Next<img src="../../assets/examinatSystem/rightIcon.png" />图标可以进入下一题。注意：如果你没有做当前题目，你将不可以进入下一题
          </li>
          <li>
            点击左下角的<img src="../../assets/examinatSystem/signoutIcon.png" />Quit 或<img src="../../assets/examinatSystem/signoutIcon.png" />End Exam 即可退出练习
          </li>
        </ul>
        <div
          class="closeBtn"
          @click="hiddenHelp"
        >
          <img src="../../assets/examinatSystem/closeIcon.png" />Close
        </div>
      </div>
    </div>
    <!-- End Exam 提示框-->
    <div
      class="EndExamTag"
      v-if="ExamTag"
    >
      <div class="examNav">
        <p>End Exam</p>
        <img
          @click="closeExam"
          src="../../assets/examinatSystem/closeIcon.png"
        />
      </div>
      <div class="examCon">
        <div class="examConFirst">
          <img src="../../assets/examinatSystem/warnIcon.png" />
          <div>
            <p>You are about to end your exam.</p>
            <p>If you click the Yes button below,your exam will end.</p>
          </div>
        </div>
        <p class="examText">Are you sure you want to end your exam?</p>
        <div class="examBtns">
          <button @click="goBank">Yes</button>
          <button @click="closeExam">No</button>
        </div>
      </div>
    </div>
    <!-- 应答确认框 -->
    <div
      class="pop"
      v-if="answerPops"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Answer Confirmation</p>
          <img
            src="../../assets/examinatSystem/closeIcon.png"
            @click="cancelExam"
          />
        </div>
        <p class="examText">
          Click Yes to confirm your answer and continue to the next question.
        </p>
        <div class="examBtns">
          <button @click="nextYes">Yes</button>
          <button @click="cancelExam">No</button>
        </div>
      </div>
    </div>
    <!-- 检查是否提交框 -->
    <div
      class="pop"
      v-if="ReviewPopup"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Review Confirmation</p>
          <img
            src="../../assets/examinatSystem/closeIcon.png"
            @click="goBack"
          />
        </div>
        <p class="examText">Are you sure you want to modify this question?</p>
        <div class="examBtns">
          <button @click="nextYes">Yes</button>
          <button @click="goBack">No</button>
        </div>
      </div>
    </div>
    <!-- 是否休息提示框 -->
    <div
      class="pop"
      v-if="showBreak"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Break Confirmation</p>
          <img
            src="../../assets/examinatSystem/closeIcon.png"
            @click="disConfirmBreak"
          />
        </div>
        <p class="examText">Are you taking a break?</p>
        <div class="examBtns">
          <button @click="confirmBreak">Yes</button>
          <button @click="disConfirmBreak">No</button>
        </div>
      </div>
    </div>
    <!-- 应答确认框 -->
    <div
      class="pop"
      v-if="shopShow"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Answer Confirmation</p>
        </div>
        <p class="examText">Suspended</p>
        <div class="examBtns">
          <button
            style="width: 120px"
            @click="suspends"
          >Resume</button>
        </div>
      </div>
    </div>
    <!-- 未应答提示框 -->
    <div
      class="pop"
      v-if="noAnswer"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Answer Confirmation</p>
          <img
            src="../../assets/examinatSystem/closeIcon.png"
            @click="cancelExam"
          />
        </div>
        <p class="examText">You cannot leave this question unanswered!</p>
        <div class="examBtns"><button @click="noAnswerConfirm">ok</button></div>
      </div>
    </div>
    <!-- 到时提示框 -->
    <div
      class="pop"
      v-if="timeout"
    >
      <div class="answerPop">
        <div class="answerNav">
          <p>Timeout Confirmation</p>
        </div>
        <p class="examText">Timeout!</p>
        <div class="examBtns"><button @click="timeoutConfirm">ok</button></div>
      </div>
    </div>
    <calculator v-if="showCalculator" />
  </div>
</template>

<script>
import api from "@/api/dryRun.js";
import apis from "@/api/record.js";
import calculator from "@/components/calculator.vue";
export default {
  components: {
    calculator,
  },
  data() {
    return {
      showCalculator: false,
      shopShow: false,
      isStart: false,
      isRouterAlive: true,
      alreadyCollect: sessionStorage.getItem("collect") == 1 ? true : false, //已收藏
      collectStatus: sessionStorage.getItem("collect") == 1 ? "已收藏" : "收藏", // 收藏状态
      checked: false,
      explainTrue: false, //课题说明下一步按钮
      tagHelp: false, //帮助弹窗
      ExamTag: false, //Eam提示框
      editPopTag: false, //纠错弹窗
      explainBtn: true, //说明按钮
      answerPops: false, //应答确认
      noAnswer: false, //未答题弹窗
      timeout: false, //到时弹框
      editVal: "", //纠错类型的值
      editArea: "", //描述错误的内容 => 纠错
      time_html: "",
      ReviewPopup: false,
      //纠错类型下拉选择
      examType: sessionStorage.getItem("examType"),
      editType: [
        {
          label: "其他",
          value: "其他",
        },
        {
          label: "题目内容错误",
          value: "题目内容错误",
        },
        {
          label: "格式错误",
          value: "格式错误",
        },
        {
          label: "答案错误",
          value: "答案错误",
        },
        {
          label: "解析错误",
          value: "解析错误",
        },
      ],
      isShowNextBtn: true,
      isShowSkipBtn: false,
      nextIndex: 0,
      //时间
      timer: "",
      content: "",
      hour: 0,
      minutes: 0,
      seconds: 0,
      //当前题目
      num: 1,
      //题目总量
      total: null,
      // isAnswer：
      isAnswer: false,
      // 各科目 数据统计DI 语文verbal
      subject: [
        {
          time: 45,
          topicCType: "DI",
        },
        {
          time: 45,
          topicCType: "Quant",
        },
        {
          time: 45,
          topicCType: "Verbal",
        },
      ],
      detail: {
        title: sessionStorage.getItem("title"),
      },
      timeOut: null,
      markStatus: sessionStorage.getItem("mark") == 1 ? true : false, //已标记
      showBreak: false,
      ifReview: sessionStorage.getItem("review") == "true",
      type: sessionStorage.getItem("topicCType"),
      isend: false,
    };
  },
  watch: {
    $route: {
      handler: async function (val) {
        if ("/examinContent/examinatStart" == val.fullPath.substr(0, 28)) {
          sessionStorage.removeItem("review");
          this.ifReview = sessionStorage.getItem("review") == "true";
        }
        this.type = sessionStorage.getItem("topicCType");
        if (sessionStorage.getItem("review") == "true") {
          this.ifReview = true;
          // this.isend = true;
        } else {
          this.ifReview = false;
        }
        this.markStatus = sessionStorage.getItem("mark") == 1 ? true : false;
        console.log("路由变化", val);
        clearInterval(this.timer);
        // if(val.path==='/explain'){
        //    this.explainTrue=true
        // }
        this.isShowNextBtn = false;
        const path = [
          "/singleChoice",
          "/completion",
          "/doubleChoice",
          "/singleChoiceBoolean",
          "/examinContent/systemRead",
          "/imageAnalysis",
          "/review",
          "/table",
          "/reasoning",
          "/choice"
        ];
        console.log(4444444444);
        for (const item of path) {
          if (val.fullPath.includes(item)) {
            this.isShowNextBtn = true;
          }
        }
        this.num = sessionStorage.getItem("nums");
        this.isAnswer = sessionStorage.getItem("isAnswer");
        console.log("222" + this.isAnswer);
        //时间 判断是否开始计时
        if (this.isShowNextBtn) {
          this.timer = setInterval(this.startTimer, 1000);
        } else {
          clearInterval(this.timer);
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  async created() {
    console.log(sessionStorage.getItem("title"));
    // this.isShowNextBtn = false;
    // const path = [
    //   "/singleChoice",
    //   "/completion",
    //   "/doubleChoice",
    //   "/singleChoiceBoolean",
    //   "/examinContent/systemRead",
    // ];
    // for (const item of path) {
    //   if (this.$route.fullPath.includes(item)) {
    //     this.isShowNextBtn = true;
    //   }
    // }
    // const total = await api.startExercise({
    //   m_id: sessionStorage.getItem("m_id"),
    //   type: sessionStorage.getItem("examType") === "模考" ? 1 : 0,
    //   isShowNextBtn: this.isShowNextBtn
    // });
    // if (total.data.code == 0) {
    //   this.detail = total.data.data;
    //   // this.total = total.data.data.topicCount;
    //   this.total = sessionStorage.getItem("topicCount");
    //   // console.log(total,'测试');
    //   // this.num = total.data.data.index;
    //   // this.startTimer()
    //   let params = {
    //     id: sessionStorage.getItem("curId"),
    //     m_id: sessionStorage.getItem("m_id"),
    //   };
    //   // const res = await api.getParam(params);
    //   // console.log("获取参数", res);
    //   //时间 判断是否开始计时
    //   // if (this.isShowNextBtn && this.isShowNextBtn) {
    //   //     this.timer = setInterval(this.startTimer, 1000);
    //   // } else {clearInterval(this.timer);}
    // } else {
    //   this.$message.error(total.data.msg);
    // }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    changeMark() {
      this.markStatus = sessionStorage.getItem("mark") == 1 ? true : false;
    },
    back() {
      this.ReviewPopup = true;
    },
    async goBack() {
      const res = await api.returnReview({
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        type: sessionStorage.getItem("topicCType"),
      });
      this.ReviewPopup = false;
      if (res.data.code == 0) {
        this.$router.replace({
          path: "/review",
        });
      }
    },
    disConfirmBreak() {
      this.showBreak = false;
      this.nextQuestion();
    },
    changeReview() {
      this.markStatus = sessionStorage.getItem("mark") == 1 ? true : false;
    },
    confirmBreak() {
      this.showBreak = false;
      this.$router.push("/resttime");
    },
    elplainNext() {
      if (this.nextIndex > 4) {
        this.$nextTick(() => {
          if (
            sessionStorage.getItem("nextType") &&
            sessionStorage.getItem("nextType") !==
              sessionStorage.getItem("topicCType")
          ) {
            this.explainTrue = false;
            this.$refs.startText.isTips = true;
            let nextType = sessionStorage.getItem("nextType");
            //题还没有做完
            // 路由判断,看是否需要重新加载页面
            const path = [
              "/singleChoice",
              "/completion",
              "/doubleChoice",
              "/singleChoiceBoolean",
              "/examinContent/systemRead",
              "/imageAnalysis",
              "/table",
              "/reasoning",
              "/choice"
            ];
            if (nextType >= 1 && nextType <= 9) {
              if (this.$route.path === path[nextType - 1]) {
                this.reload();
              } else {
                this.$router.replace({
                  path: path[nextType - 1],
                });
              }
            }
          }
        });
        return;
      }
      this.nextIndex++;
      if (this.nextIndex == 5) {
        this.startExam();
      }
    },
    changIndex(index) {
      this.nextIndex = index;
    },
    isTipsFun(value) {
      if (value) {
        console.log(11111);
        this.explainTrue = true;
        if (this.nextIndex < 5) {
          this.isShowSkipBtn = true;
        } else {
          this.isShowSkipBtn = false;
        }
        this.$refs.startText.isTips = false;
      } else {
        this.explainTrue = false;
        this.isShowSkipBtn = false;
      }
    },
    // 时间计时
    startTimer() {
      // if (window.location.href.indexOf('systemRead') == -1) {
      //   clearInterval(this.timer);
      //   console.log(1)
      // }
      let time = sessionStorage.getItem("isFirst");
      let choice = null;
      // 模考 练习
      let examType = (time = sessionStorage.getItem("examType"));
      if (
        sessionStorage.getItem("choice") &&
        sessionStorage.getItem("choice") != "undefined"
      ) {
        choice = JSON.parse(sessionStorage.getItem("choice"));
      }
      if (time) {
        this.alreadyCollect =
          sessionStorage.getItem("collect") == 1 ? true : false; //已收藏
        this.collectStatus =
          sessionStorage.getItem("collect") == 1 ? "已收藏" : "收藏"; // 收藏状态
        // if (!choice || choice.choice == 1) {
        this.shopShow = choice.suspend_status || false;
        if (examType == "练习") {
          let times = !choice.time
            ? 0
            : parseInt(new Date().getTime() / 1000) - choice.time;
          if (choice.suspend) {
            times -= choice.suspend;
          }
          if (choice.suspend_start) {
            times -= choice.suspend_start;
          }
          if (times < 0) {
            times = 0;
          }
          this.seconds = times % 60;
          this.minutes = parseInt(times / 60);
          this.seconds += 1;
          if (this.seconds >= 60) {
            this.seconds = 0;
            this.minutes = this.minutes + 1;
          }
          if (this.minutes >= 60) {
            this.minutes = 0;
            this.hour = this.hour + 1;
          }
          this.time_html =
            (this.minutes < 8 ? "0" + this.minutes : this.minutes) +
            ":" +
            (this.seconds < 8 ? "0" + this.seconds : this.seconds);
        } else if (examType == "模考" && choice) {
          let now = !choice.time
            ? 0
            : parseInt(new Date().getTime() / 1000) - choice.time;
          let times = 0;
          if (choice.choice == 0) {
            // 获取各科目、
            let type = sessionStorage.getItem("topicCType");
            // 判断是否 赋值时间
            switch (type) {
              case this.subject[0].topicCType:
                times = this.subject[0].time * 60 - now;
                break;
              case this.subject[1].topicCType:
                times = this.subject[1].time * 60 - now;
                break;
              case this.subject[2].topicCType:
                times = this.subject[2].time * 60 - now;
                break;
              default:
                return;
            }
          } else {
            times = choice.duration - now;
          }
          if (choice.suspend) {
            times += choice.suspend;
            console.log(choice);
            if (choice.suspend_start && choice.suspend_start > 0) {
              times +=
                parseInt(new Date().getTime() / 1000) - choice.suspend_start;
            }
          }
          if (times <= 0) {
            if (!this.timeout) {
              this.timeout = true;
            }
            this.time_html = "";
            return;
          }
          this.seconds = times % 60;
          this.minutes = parseInt(times / 60);
          this.time_html =
            (this.minutes < 8 ? "0" + this.minutes : this.minutes) +
            ":" +
            (this.seconds < 8 ? "0" + this.seconds : this.seconds);
        }
        if (this.shopShow) {
          clearInterval(this.timer);
          return;
        }
      } else {
        this.time_html = "";
        clearInterval(this.timer);
      }
    },
    noAnswerConfirm() {
      this.noAnswer = false;
    },
    async getMark() {
      let params = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        q_id: sessionStorage.getItem("q_id"),
      };
      const res = await api.mark(params);
      sessionStorage.setItem(
        "mark",
        sessionStorage.getItem("mark") == 1 ? 0 : 1
      );
      this.markStatus = sessionStorage.getItem("mark") == 1 ? true : false;
    },
    async timeoutConfirm() {
      let params = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        q_id: sessionStorage.getItem("q_id"),
        answer: sessionStorage.getItem("answer") || JSON.stringify([]),
        timeout: true,
      };
      this.timeout = false;
      const res = await api.submitAnswer(params);
      if (res.data.code === 0) {
        //情况答题答案缓存
        sessionStorage.removeItem("choice");
        sessionStorage.setItem("answer", "");
        sessionStorage.setItem("isAnswer", false);
        if (res.data.data.isend === 0) {
          let topicCType = sessionStorage.getItem("topicCType");
          sessionStorage.setItem("nextType", res.data.data.nextType);
          if (
            topicCType != res.data.data.nextCType &&
            res.data.data.is_rest === 0
          ) {
            this.time_html = "";
            clearInterval(this.timer);
            sessionStorage.removeItem("choice");
            // sessionStorage.setItem("time", 0);
            sessionStorage.setItem("isFirst", false);
            sessionStorage.setItem("nextCType", res.data.data.nextCType);
            sessionStorage.setItem("nextCount", res.data.data.nextCount);
            this.$router.push("/resttime");
          } else {
            //题还没有做完
            // 路由判断,看是否需要重新加载页面
            const path = [
              "/singleChoice",
              "/completion",
              "/doubleChoice",
              "/singleChoiceBoolean",
              "/examinContent/systemRead",
              "/imageAnalysis",
              "/table",
              "/reasoning",
              "/choice"
            ];
            console.log(1111111111);
            const nextType = res.data.data.nextType;
            if (nextType >= 1 && nextType <= 9) {
              if (this.$route.path === path[nextType - 1]) {
                this.reload();
              } else {
                this.$router.replace({
                  path: path[nextType - 1],
                });
              }
            }
          }
        } else {
          // 停止时间
          clearInterval(this.timer);
          //题做完了
          this.$router.push({
            path: "/scheduleMatter",
          });
          location.reload();
        }
      }
    },
    //错题本收藏
    needCollect(id) {
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      apis
        .joinCollect(query)
        .then((res) => {
          this.alreadyCollect = true;
          this.collectStatus = "已收藏";
          sessionStorage.setItem("collect", 1);
          this.$message.success("收藏成功");
        })
        .catch((err) => {
          this.$message.error("收藏失败");
        });
    },
    //取消收藏 => 错题本
    unNeedCollect(id) {
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      apis
        .outCollect(query)
        .then((res) => {
          this.alreadyCollect = false;
          this.collectStatus = "收藏";
          sessionStorage.setItem("collect", 0);
          this.$message.success("取消收藏成功");
        })
        .catch((err) => {
          this.$message.error("取消收藏失败");
        });
    },
    //收藏题目
    lookCollect() {
      if (!this.alreadyCollect) {
        this.needCollect(sessionStorage.getItem("q_id"));
      } else {
        this.unNeedCollect(sessionStorage.getItem("q_id"));
      }
    },
    //弹窗显示 help
    lookHelp() {
      this.tagHelp = true;
    },
    //弹窗隐藏 Help
    hiddenHelp() {
      this.tagHelp = false;
    },
    //弹窗显示 Exam
    lookExam() {
      this.ExamTag = true;
    },
    //弹窗隐藏 Exam
    closeExam() {
      this.ExamTag = false;
    },
    //弹窗Yes跳转 Exam
    goBank() {
      if (sessionStorage.getItem("examType") === "练习") {
        this.$router.push("/onlinePractice");
      } else {
        this.$router.push("/questionBank");
      }
      this.ExamTag = false;
      // 停止时间
      clearInterval(this.timer);
    },
    //Resume Exam 暂停时间
    async suspend() {
      let params = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
      };
      const suspend = !this.ifReview ? api.suspend : api.suspendReview;
      const res = await suspend(params);
      if (res.data.code === 0) {
        clearInterval(this.timer);
        let choice = JSON.parse(sessionStorage.getItem("choice"));
        choice.suspend_status = true;
        sessionStorage.setItem("choice", JSON.stringify(choice));
        this.shopShow = true;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async suspends() {
      let params = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
      };
      const res = await api.suspend(params);
      if (res.data.code === 0) {
        let choice = JSON.parse(sessionStorage.getItem("choice"));
        choice.suspend_status = false;
        choice.suspend_start = 0;
        if (choice.suspend) {
          choice.suspend = choice.suspend + res.data.data;
        } else {
          choice.suspend = res.data.data;
        }
        sessionStorage.setItem("choice", JSON.stringify(choice));
        this.shopShow = false;
        this.timer = setInterval(this.startTimer, 1000);
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //next按钮
    async nextExam() {
      console.log();
      if (this.$route.fullPath == "/review") {
        let res = await api.endReview({
          id: sessionStorage.getItem("curId"),
          m_id: sessionStorage.getItem("m_id"),
          type: sessionStorage.getItem("topicCType"),
        });
        if (res.data.code === 0) {
          //情况答题答案缓存
          sessionStorage.setItem("answer", "");
          sessionStorage.setItem("isAnswer", false);
          if (!res.data.isend) {
            if (res.data.data) {
              this.nextQuestion();
            } else {
              this.showBreak = true;
            }
          } else {
            // 停止时间
            clearInterval(this.timer);
            console.log("答题完成，停止时间1");
            //题做完了
            this.$router.push({
              path: "/scheduleMatter",
            });
            location.reload();
            return;
          }
        }
        return;
      }

      console.log(sessionStorage.getItem("isAnswer") == "false");
      if (
        sessionStorage.getItem("isAnswer") == "false" ||
        sessionStorage.getItem("isAnswer") == null
      ) {
        this.noAnswer = true;
      } else {
        this.answerPops = true;
      }
      // let curRouter = this.$route.fullPath
    },
    nextQuestion() {
      sessionStorage.removeItem("review");
      let changIndex = 5;
      if (sessionStorage.getItem("nextCType") === "Verbal") {
        changIndex = 6;
      } else if (sessionStorage.getItem("nextCType") === "DI") {
        changIndex = 7;
      }
      this.nextIndex = changIndex;
      this.$refs.startText.isTips = false;
      const id = sessionStorage.getItem("m_id");
      this.$router.replace({ path: `/examinContent/examinatStart/${id}` });
      return;
      let nextType = sessionStorage.getItem("nextType");
      //题还没有做完
      // 路由判断,看是否需要重新加载页面
      const path = [
        "/singleChoice",
        "/completion",
        "/doubleChoice",
        "/singleChoiceBoolean",
        "/examinContent/systemRead",
        "/imageAnalysis",
        "/table",
        "/reasoning",
      ];
      if (nextType >= 1 && nextType <= 8) {
        if (this.$route.path === path[nextType - 1]) {
          this.reload();
        } else {
          this.$router.replace({
            path: path[nextType - 1],
          });
        }
      }
    },
    //下一题，确认
    async nextYes() {
      this.answerPops = false;
      this.num = sessionStorage.getItem("nums");
      // document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
      if (sessionStorage.getItem("examType") === "练习") {
        let params = {
          id: sessionStorage.getItem("curId"),
          m_id: sessionStorage.getItem("m_id"),
          q_id: sessionStorage.getItem("q_id"),
          answer: sessionStorage.getItem("answer"),
        };
        this.isend = false;
        const res = await api.submitExerciseAnswer(params);
        if (res.data.code === 0) {
          if (res.data.data.isend === 0) {
            sessionStorage.setItem("isAnswer", false);
            const path = [
              "/singleChoice",
              "/completion",
              "/doubleChoice",
              "/singleChoiceBoolean",
              "/examinContent/systemRead",
              "/imageAnalysis",
              "/table",
              "/reasoning",
              "/choice"
            ];
            console.log(22222222222222);
            const nextType = res.data.data.nextType;
            if (nextType >= 1 && nextType <= 9) {
              if (this.$route.path === path[nextType - 1]) {
                this.reload();
              } else {
                this.$router.replace({
                  path: path[nextType - 1],
                });
              }
            }
          } else {
            clearInterval(this.timer);
            console.log("练习题做完了");
            this.$router.push("/exerciseResult");
          }
        } else {
          this.$message.error("提交答案失败！");
        }
      } else {
        let params = {
          id: sessionStorage.getItem("curId"),
          m_id: sessionStorage.getItem("m_id"),
          q_id: sessionStorage.getItem("q_id"),
          answer: sessionStorage.getItem("answer"),
        };
        const res = await api.submitAnswer(params);
        console.log("答题然后跳下一题", res);
        this.isend = false;
        if (res.data.code === 0) {
          //情况答题答案缓存
          sessionStorage.setItem("answer", "");
          sessionStorage.setItem("isAnswer", false);
          if (this.ifReview) {
            this.goBack();
            return;
          }
          if (res.data.data.isend === 0) {
            let topicCType = sessionStorage.getItem("topicCType");
            if (
              topicCType != res.data.data.nextCType &&
              res.data.data.is_rest === 0
            ) {
              sessionStorage.removeItem("choice");
              sessionStorage.setItem("isFirst", false);
              sessionStorage.setItem("nextType", res.data.data.nextType);
              sessionStorage.setItem("nextCType", res.data.data.nextCType);
              sessionStorage.setItem("nextCount", res.data.data.nextCount);
              this.$router.replace({
                path: "/review",
              });
              // this.showBreak = true;
              // this.$router.push("/resttime");
            } else {
              if (topicCType != res.data.data.nextCType) {
                sessionStorage.removeItem("choice");
                sessionStorage.setItem("isFirst", false);
                sessionStorage.setItem("nextType", res.data.data.nextType);
                sessionStorage.setItem("nextCType", res.data.data.nextCType);
                sessionStorage.setItem("nextCount", res.data.data.nextCount);
                this.$router.replace({
                  path: "/review",
                });
              } else {
                const path = [
                  "/singleChoice",
                  "/completion",
                  "/doubleChoice",
                  "/singleChoiceBoolean",
                  "/examinContent/systemRead",
                  "/imageAnalysis",
                  "/table",
                  "/reasoning",
                  "/choice"
                ];
                console.log(3333333333);
                const nextType = res.data.data.nextType;
                if (nextType >= 1 && nextType <= 9) {
                  if (this.$route.path === path[nextType - 1]) {
                    this.reload();
                  } else {
                    this.$router.replace({
                      path: path[nextType - 1],
                    });
                  }
                }
              }
              //题还没有做完
              // 路由判断,看是否需要重新加载页面
            }
          } else {
            this.isend = true;
            this.$router.replace({
              path: "/review",
            });
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }
    },
    //next 弹窗  取消
    cancelExam() {
      this.answerPops = false;
      console.log("取消");
    },
    //纠错弹窗
    lookEidt() {
      this.editPopTag = true;
    },
    //纠错弹窗  => 确定
    async yesEdit() {
      let m_id = sessionStorage.getItem("m_id");
      let q_id = sessionStorage.getItem("q_id");
      if (!m_id) {
        this.$message.error("无效试卷");
        return;
      }
      if (!q_id) {
        this.$message.error("无效题目");
        return;
      }
      if (!this.editVal) {
        this.$message.error("请选择类型!");
        return;
      }
      if (!this.editArea) {
        this.$message.error("请描述错误内容!");
        return;
      }
      const total = await api.errorCorrection({
        m_id,
        t_id: q_id,
        type: this.editVal,
        content: this.editArea,
      });
      if (total.data.code == 0) {
        this.editVal = "";
        this.editArea = "";
        this.$message.success("提交成功");
        this.cancelEdit();
      } else {
        this.$message.error(total.data.msg);
      }
    },
    //纠错弹窗 =>  取消
    cancelEdit() {
      this.editPopTag = false;
    },
    //跳转至考试
    startExam() {
      this.isStart = true;
      this.$nextTick(() => {
        this.$refs.startText.clickNext();
      });
      // this.$router.push('systemRead');
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/examinContent.css");

.startConRight {
  height: 86vh;
  overflow-y: auto;
}

.isbottomBtn {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #006eae;
  min-width: 1024px;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 99999;
}

.startCons {
  width: 98%;
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/examinatSystem/examinContent.vue